export class PdfEntry
{
    LogEntryNumber: number;
    FileName: string;
    Company: string;
}


export class PdfEntryWithType {
    LogEntryNumber: number;
    FileName: string;
    Company: string;
    type: string; 

    constructor(entry: PdfEntry, type: string) {
        this.LogEntryNumber = entry.LogEntryNumber;
        this.FileName = entry.FileName;
        this.Company = entry.Company;
        this.type = type; 
    }
}